<nav>
  <ul class="tab-menu">
    <ng-content></ng-content>
  </ul>
</nav>
